import { useQuery } from '@apollo/client';
import React, { useState, useEffect, useRef, useCallback, PropsWithChildren } from 'react'
import styled from 'styled-components';
import { ContentState, convertToRaw, EditorState, Modifier, RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import '@draft-js-plugins/mention/lib/plugin.css';
import '@szhsin/react-menu/dist/core.css';
import '@draft-js-plugins/inline-toolbar/lib/plugin.css';

import Editor from '@draft-js-plugins/editor';
import createInlineToolbarPlugin from '@draft-js-plugins/inline-toolbar';
import createMentionPlugin, {
  defaultSuggestionsFilter, MentionData,
} from '@draft-js-plugins/mention';
import { convertToHTML } from 'draft-convert'
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import createLinkPlugin from '@draft-js-plugins/anchor';
import { FormikErrors, FormikTouched } from 'formik';

import { Box, Button, Flex, Text } from 'rebass/styled-components';
import { IGetHelpscoutUsersOutput, IHelpscoutUser, IIGetHelpscoutUsersInput } from '../../../../graphql/types/queries/conversation';
import { GET_HELPSCOUT_USERS } from '../../../../graphql/queries';
import Select from 'react-select';
import { ReactSelectStyles } from '../../../../styles/ReactSelectStyles';
import withSession from '../../../../lib/withSession';
import { IUser } from '../../../../graphql/types/queries/user';
import ReactTooltip from 'react-tooltip';
import Modal, { BaseModalBackground } from 'styled-react-modal';
// import { InsertLinkModalContent, linkDecorator, linkDecorators } from './draftPlugins/CustomLinkPlugin';
import linkStyles from '../../../../styles/linkStyles.module.css'
import { useDropzone } from 'react-dropzone';
// import { AttachmentFile } from './AttachmentFile';
import { sleep } from '../../../../utils/sleep';
import { InsertLinkModalContent, linkDecorator, linkDecorators } from '../../../messages/components/draftPlugins/CustomLinkPlugin';
import { IProperties } from '../../builder/types';
import FormField from '../../../../components/FormField';
import './customStyle/styles.css'
// import AddResourceModal from './modalsContents/AddResource';

const SpecialModalBackground = styled(BaseModalBackground)`
z-index: 10000;
`
const getColor = ({ isDragAccept, isDragReject, isFocused }: { isDragAccept?: boolean, isDragReject?: boolean, isFocused?: boolean }) => {
  if (isDragAccept) {
    return '2px dashed #556575';
  }
  if (isDragReject) {
    return '2px dashed #ff1744';
  }
  if (isFocused) {
    return '2px dashed #2196f3';
  }
  return '2px dashed transparent';
}

const Container = styled(Flex)`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  min-height: 250px;
  position:relative;
  background: white;
  margin: 0;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  /* background-color: red; */
`;
interface ITextEditorProps {
  properties: IProperties,
  name: string,
  values: any,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  session: IUser,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>
  // onDeleteHandler: () => void,
  // sendReplyHandler: (html: string, assignTo: number, status: string, attachments?: Array<{
  //   fileName: string,
  //   mimeType: string,
  //   data: string,
  //   size: number,
  // }> | null) => void
}

// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

function getBlockStyle(block: any) {
  switch (block.getType()) {
    case 'blockquote': return 'RichEditor-blockquote';
    default: return null;
  }
}

const Svg = styled.svg`
`
const Path = styled.path`
`

const Btn = styled(Flex) <{ isActive: boolean }>`
  height: 28px;
  width: 28px;
  margin-bottom: 8px;
  background-color: ${({ isActive }) => isActive ? '#7385A3' : 'transparent'};
  justify-content: center;
  align-items: center;
    >${Svg} {
      >${Path}{
      fill:${({ isActive }) => isActive ? 'white' : '#9BA2B4'}; ;
      }
    }
  &:hover{
    background-color: #e5e9ec;  
    >${Svg} {
      >${Path}{
      fill:${({ isActive }) => isActive ? '#6a7383' : '#6a7383'}; ;
      }
    }  
  }
`
const EditorWrapper = styled(Flex)`
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`

class StyleButton extends React.Component<any> {
  onToggle = (e: any) => {
    e.preventDefault();
    this.props.onToggle(this.props.style);
    if (this.props.onClick) {
      this.props.onClick()
    }
  };
  render() {
    return (
      <Btn isActive={this.props.active} onMouseDown={this.onToggle} data-tip={this.props.dataTip}>
        {!!this.props.icon ? (this.props.icon) : (this.props.label)}
      </Btn>
    );
  }
}

const BLOCK_TYPES = [
  {
    label: 'Unordered list', icon: (<Svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path d="M44.5312 9.375H16.0156C15.8008 9.375 15.625 9.55078 15.625 9.76562V12.5C15.625 12.7148 15.8008 12.8906 16.0156 12.8906H44.5312C44.7461 12.8906 44.9219 12.7148 44.9219 12.5V9.76562C44.9219 9.55078 44.7461 9.375 44.5312 9.375ZM44.5312 23.2422H16.0156C15.8008 23.2422 15.625 23.418 15.625 23.6328V26.3672C15.625 26.582 15.8008 26.7578 16.0156 26.7578H44.5312C44.7461 26.7578 44.9219 26.582 44.9219 26.3672V23.6328C44.9219 23.418 44.7461 23.2422 44.5312 23.2422ZM44.5312 37.1094H16.0156C15.8008 37.1094 15.625 37.2852 15.625 37.5V40.2344C15.625 40.4492 15.8008 40.625 16.0156 40.625H44.5312C44.7461 40.625 44.9219 40.4492 44.9219 40.2344V37.5C44.9219 37.2852 44.7461 37.1094 44.5312 37.1094ZM5.07812 11.1328C5.07812 11.4919 5.14885 11.8475 5.28627 12.1792C5.42368 12.511 5.62509 12.8124 5.87901 13.0663C6.13292 13.3202 6.43435 13.5216 6.7661 13.659C7.09785 13.7965 7.45342 13.8672 7.8125 13.8672C8.17158 13.8672 8.52715 13.7965 8.8589 13.659C9.19065 13.5216 9.49208 13.3202 9.74599 13.0663C9.99991 12.8124 10.2013 12.511 10.3387 12.1792C10.4761 11.8475 10.5469 11.4919 10.5469 11.1328C10.5469 10.7737 10.4761 10.4182 10.3387 10.0864C10.2013 9.75466 9.99991 9.45323 9.74599 9.19932C9.49208 8.94541 9.19065 8.74399 8.8589 8.60658C8.52715 8.46916 8.17158 8.39844 7.8125 8.39844C7.45342 8.39844 7.09785 8.46916 6.7661 8.60658C6.43435 8.74399 6.13292 8.94541 5.87901 9.19932C5.62509 9.45323 5.42368 9.75466 5.28627 10.0864C5.14885 10.4182 5.07812 10.7737 5.07812 11.1328V11.1328ZM5.07812 25C5.07812 25.3591 5.14885 25.7147 5.28627 26.0464C5.42368 26.3782 5.62509 26.6796 5.87901 26.9335C6.13292 27.1874 6.43435 27.3888 6.7661 27.5262C7.09785 27.6636 7.45342 27.7344 7.8125 27.7344C8.17158 27.7344 8.52715 27.6636 8.8589 27.5262C9.19065 27.3888 9.49208 27.1874 9.74599 26.9335C9.99991 26.6796 10.2013 26.3782 10.3387 26.0464C10.4761 25.7147 10.5469 25.3591 10.5469 25C10.5469 24.6409 10.4761 24.2853 10.3387 23.9536C10.2013 23.6219 9.99991 23.3204 9.74599 23.0665C9.49208 22.8126 9.19065 22.6112 8.8589 22.4738C8.52715 22.3364 8.17158 22.2656 7.8125 22.2656C7.45342 22.2656 7.09785 22.3364 6.7661 22.4738C6.43435 22.6112 6.13292 22.8126 5.87901 23.0665C5.62509 23.3204 5.42368 23.6219 5.28627 23.9536C5.14885 24.2853 5.07812 24.6409 5.07812 25V25ZM5.07812 38.8672C5.07812 39.2263 5.14885 39.5818 5.28627 39.9136C5.42368 40.2453 5.62509 40.5468 5.87901 40.8007C6.13292 41.0546 6.43435 41.256 6.7661 41.3934C7.09785 41.5308 7.45342 41.6016 7.8125 41.6016C8.17158 41.6016 8.52715 41.5308 8.8589 41.3934C9.19065 41.256 9.49208 41.0546 9.74599 40.8007C9.99991 40.5468 10.2013 40.2453 10.3387 39.9136C10.4761 39.5818 10.5469 39.2263 10.5469 38.8672C10.5469 38.5081 10.4761 38.1525 10.3387 37.8208C10.2013 37.489 9.99991 37.1876 9.74599 36.9337C9.49208 36.6798 9.19065 36.4784 8.8589 36.341C8.52715 36.2035 8.17158 36.1328 7.8125 36.1328C7.45342 36.1328 7.09785 36.2035 6.7661 36.341C6.43435 36.4784 6.13292 36.6798 5.87901 36.9337C5.62509 37.1876 5.42368 37.489 5.28627 37.8208C5.14885 38.1525 5.07812 38.5081 5.07812 38.8672V38.8672Z" />
    </Svg>
    ), style: 'unordered-list-item'
  },
  {
    label: 'Ordered list', icon: (<Svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path fillRule="evenodd" clipRule="evenodd" d="M15.625 35.9375C15.625 35.5231 15.7896 35.1257 16.0826 34.8326C16.3757 34.5396 16.7731 34.375 17.1875 34.375H45.3125C45.7269 34.375 46.1243 34.5396 46.4174 34.8326C46.7104 35.1257 46.875 35.5231 46.875 35.9375C46.875 36.3519 46.7104 36.7493 46.4174 37.0424C46.1243 37.3354 45.7269 37.5 45.3125 37.5H17.1875C16.7731 37.5 16.3757 37.3354 16.0826 37.0424C15.7896 36.7493 15.625 36.3519 15.625 35.9375ZM15.625 23.4375C15.625 23.0231 15.7896 22.6257 16.0826 22.3326C16.3757 22.0396 16.7731 21.875 17.1875 21.875H45.3125C45.7269 21.875 46.1243 22.0396 46.4174 22.3326C46.7104 22.6257 46.875 23.0231 46.875 23.4375C46.875 23.8519 46.7104 24.2493 46.4174 24.5424C46.1243 24.8354 45.7269 25 45.3125 25H17.1875C16.7731 25 16.3757 24.8354 16.0826 24.5424C15.7896 24.2493 15.625 23.8519 15.625 23.4375ZM15.625 10.9375C15.625 10.5231 15.7896 10.1257 16.0826 9.83265C16.3757 9.53962 16.7731 9.375 17.1875 9.375H45.3125C45.7269 9.375 46.1243 9.53962 46.4174 9.83265C46.7104 10.1257 46.875 10.5231 46.875 10.9375C46.875 11.3519 46.7104 11.7493 46.4174 12.0424C46.1243 12.3354 45.7269 12.5 45.3125 12.5H17.1875C16.7731 12.5 16.3757 12.3354 16.0826 12.0424C15.7896 11.7493 15.625 11.3519 15.625 10.9375Z" />
      <Path d="M5.35313 37.0781V35.5969H6.25C6.92812 35.5969 7.38437 35.1688 7.38437 34.6063C7.38437 34.0281 6.89063 33.6375 6.25625 33.6375C5.55938 33.6375 5.10937 34.1125 5.09062 34.6063H3.24688C3.29688 33.1469 4.4125 32.1469 6.32813 32.1469C8.16563 32.1406 9.30938 33.0563 9.31875 34.3438C9.32467 34.7854 9.17321 35.2146 8.8915 35.5547C8.60979 35.8949 8.21622 36.1236 7.78125 36.2V36.3031C8.27441 36.3399 8.7344 36.5654 9.06558 36.9326C9.39675 37.2999 9.57361 37.7807 9.55938 38.275C9.56875 39.9406 7.99062 40.775 6.275 40.775C4.225 40.775 3.15 39.6188 3.125 38.2938H4.94375C4.96875 38.85 5.525 39.25 6.2625 39.2594C7.05625 39.2594 7.5875 38.8063 7.58125 38.1656C7.575 37.5563 7.09688 37.0781 6.2875 37.0781H5.35H5.35313ZM5.34062 22.3938H3.45313V22.2844C3.45313 21.0094 4.375 19.6469 6.44687 19.6469C8.26875 19.6469 9.44688 20.6656 9.44688 22.0094C9.44688 23.225 8.64375 23.9375 7.95937 24.6594L6.28125 26.4469V26.5406H9.575V28.125H3.57188V26.8906L6.5625 23.7969C6.99375 23.3531 7.47812 22.8469 7.47812 22.2094C7.47812 21.6469 7.01875 21.2094 6.40938 21.2094C6.2687 21.2042 6.12845 21.2279 5.99728 21.279C5.8661 21.3301 5.74678 21.4075 5.64665 21.5065C5.54653 21.6054 5.46772 21.7238 5.41509 21.8544C5.36246 21.985 5.33712 22.1249 5.34062 22.2656V22.3938ZM8.0125 15.625H6.02813V9.13751H5.93125L4.0625 10.45V8.67814L6.02813 7.29376H8.0125V15.625Z" />
    </Svg>
    ), style: 'ordered-list-item'
  },
  {
    label: 'Code block', icon: (<Svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path d="M32.7446 5.14686C32.8049 4.9507 32.826 4.74458 32.8067 4.54026C32.7873 4.33594 32.728 4.13744 32.6319 3.95607C32.5359 3.77471 32.405 3.61404 32.2469 3.48324C32.0887 3.35243 31.9064 3.25406 31.7102 3.19374C31.5141 3.13341 31.3079 3.11231 31.1036 3.13165C30.8993 3.15098 30.7008 3.21037 30.5194 3.30642C30.3381 3.40247 30.1774 3.5333 30.0466 3.69145C29.9158 3.84959 29.8174 4.03195 29.7571 4.22811L17.2571 44.8531C17.1353 45.2493 17.1758 45.6776 17.3698 46.0439C17.5638 46.4102 17.8953 46.6844 18.2915 46.8062C18.6876 46.9281 19.116 46.8875 19.4823 46.6936C19.8485 46.4996 20.1228 46.168 20.2446 45.7719L32.7446 5.14686V5.14686ZM15.1696 12.9562C15.3151 13.1014 15.4305 13.2738 15.5093 13.4636C15.5881 13.6535 15.6286 13.857 15.6286 14.0625C15.6286 14.268 15.5881 14.4715 15.5093 14.6613C15.4305 14.8512 15.3151 15.0236 15.1696 15.1687L5.33522 25L15.1696 34.8312C15.463 35.1246 15.6278 35.5226 15.6278 35.9375C15.6278 36.3524 15.463 36.7503 15.1696 37.0437C14.8762 37.3371 14.4783 37.502 14.0633 37.502C13.6484 37.502 13.2505 37.3371 12.9571 37.0437L2.01959 26.1062C1.87408 25.9611 1.75863 25.7887 1.67986 25.5988C1.60109 25.409 1.56055 25.2055 1.56055 25C1.56055 24.7945 1.60109 24.591 1.67986 24.4011C1.75863 24.2113 1.87408 24.0389 2.01959 23.8937L12.9571 12.9562C13.1022 12.8107 13.2747 12.6953 13.4645 12.6165C13.6543 12.5377 13.8578 12.4972 14.0633 12.4972C14.2689 12.4972 14.4724 12.5377 14.6622 12.6165C14.852 12.6953 15.0244 12.8107 15.1696 12.9562V12.9562ZM34.8321 12.9562C34.6866 13.1014 34.5711 13.2738 34.4924 13.4636C34.4136 13.6535 34.373 13.857 34.373 14.0625C34.373 14.268 34.4136 14.4715 34.4924 14.6613C34.5711 14.8512 34.6866 15.0236 34.8321 15.1687L44.6665 25L34.8321 34.8312C34.6868 34.9765 34.5716 35.149 34.493 35.3388C34.4143 35.5286 34.3739 35.732 34.3739 35.9375C34.3739 36.1429 34.4143 36.3464 34.493 36.5362C34.5716 36.726 34.6868 36.8985 34.8321 37.0437C34.9774 37.189 35.1498 37.3043 35.3396 37.3829C35.5295 37.4615 35.7329 37.502 35.9383 37.502C36.1438 37.502 36.3472 37.4615 36.537 37.3829C36.7268 37.3043 36.8993 37.189 37.0446 37.0437L47.9821 26.1062C48.1276 25.9611 48.243 25.7887 48.3218 25.5988C48.4006 25.409 48.4411 25.2055 48.4411 25C48.4411 24.7945 48.4006 24.591 48.3218 24.4011C48.243 24.2113 48.1276 24.0389 47.9821 23.8937L37.0446 12.9562C36.8994 12.8107 36.727 12.6953 36.5372 12.6165C36.3474 12.5377 36.1439 12.4972 35.9383 12.4972C35.7328 12.4972 35.5293 12.5377 35.3395 12.6165C35.1497 12.6953 34.9772 12.8107 34.8321 12.9562V12.9562Z" />
    </Svg>
    ), style: 'code-block'
  },
  { isSpread: true },
  // {
  //   label: 'Delete', icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M3.75 5.99997H2.25C2.05109 5.99997 1.86032 5.92096 1.71967 5.7803C1.57902 5.63965 1.5 5.44889 1.5 5.24997C1.5 5.05106 1.57902 4.8603 1.71967 4.71964C1.86032 4.57899 2.05109 4.49997 2.25 4.49997H8.25V2.24847C8.25 2.04956 8.32902 1.8588 8.46967 1.71814C8.61032 1.57749 8.80109 1.49847 9 1.49847H15C15.1989 1.49847 15.3897 1.57749 15.5303 1.71814C15.671 1.8588 15.75 2.04956 15.75 2.24847V4.49997H21.75C21.9489 4.49997 22.1397 4.57899 22.2803 4.71964C22.421 4.8603 22.5 5.05106 22.5 5.24997C22.5 5.44889 22.421 5.63965 22.2803 5.7803C22.1397 5.92096 21.9489 5.99997 21.75 5.99997H20.25V21.75C20.25 21.9489 20.171 22.1397 20.0303 22.2803C19.8897 22.421 19.6989 22.5 19.5 22.5H4.5C4.30109 22.5 4.11032 22.421 3.96967 22.2803C3.82902 22.1397 3.75 21.9489 3.75 21.75V5.99997ZM14.25 4.49997V2.99997H9.75V4.49997H14.25ZM5.25 21H18.75V5.99997H5.25V21ZM9.75 18C9.55109 18 9.36032 17.921 9.21967 17.7803C9.07902 17.6397 9 17.4489 9 17.25V9.74997C9 9.55106 9.07902 9.3603 9.21967 9.21964C9.36032 9.07899 9.55109 8.99997 9.75 8.99997C9.94891 8.99997 10.1397 9.07899 10.2803 9.21964C10.421 9.3603 10.5 9.55106 10.5 9.74997V17.25C10.5 17.4489 10.421 17.6397 10.2803 17.7803C10.1397 17.921 9.94891 18 9.75 18ZM14.25 18C14.0511 18 13.8603 17.921 13.7197 17.7803C13.579 17.6397 13.5 17.4489 13.5 17.25V9.74997C13.5 9.55106 13.579 9.3603 13.7197 9.21964C13.8603 9.07899 14.0511 8.99997 14.25 8.99997C14.4489 8.99997 14.6397 9.07899 14.7803 9.21964C14.921 9.3603 15 9.55106 15 9.74997V17.25C15 17.4489 14.921 17.6397 14.7803 17.7803C14.6397 17.921 14.4489 18 14.25 18Z"  />
  //   </svg>
  //   ), style: 'code-block'
  // },
];

const BlockStyleControls = (props: any) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  let arr = BLOCK_TYPES

  return (
    <>
      {arr.map((type) => {
        if (type.isSpread) {
          return <Flex flex={1}
            key={'spread'}></Flex>
        }
        if (type.label === 'Delete') {
          return (<StyleButton
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            icon={type.icon}
            dataTip={'Discard'}
            onToggle={() => {
              if (props.onDeleteHandler) {
                props.onDeleteHandler()
              }
            }}
            style={type.style}
          />)
        }
        return (<StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          icon={type.icon}
          onToggle={props.onToggle}
          dataTip={type.label}
          style={type.style}
        />)
      }
      )}
    </>
  );
};

var INLINE_STYLES = [
  // {
  //   label: 'Attach', icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M18.2031 1.9043C17.8391 1.91778 17.4791 1.98561 17.1351 2.10553C15.7514 2.57168 14.5643 3.63784 13.3856 4.81753L5.77017 12.4329C5.09356 13.1095 4.57202 13.9348 4.41417 14.9132C4.33339 15.4464 4.3802 15.9911 4.55078 16.5026C4.72135 17.0142 5.01081 17.478 5.3954 17.856C5.78209 18.2442 6.25668 18.5333 6.77893 18.699C7.30118 18.8647 7.85568 18.902 8.3954 18.8077C9.37202 18.6323 10.1899 18.1089 10.8185 17.4803L19.1834 9.11537C19.2844 9.03413 19.3671 8.93253 19.4262 8.81719C19.4853 8.70185 19.5195 8.57536 19.5265 8.44595C19.5334 8.31654 19.5131 8.1871 19.4668 8.06608C19.4204 7.94505 19.3491 7.83513 19.2574 7.74349C19.1658 7.65185 19.0559 7.58053 18.9349 7.53418C18.8138 7.48783 18.6844 7.46749 18.555 7.47447C18.4256 7.48145 18.2991 7.51561 18.1837 7.57472C18.0684 7.63382 17.9668 7.71656 17.8856 7.81753L9.51971 16.1825C9.12279 16.5794 8.57448 16.9015 8.07787 16.9901C7.58125 17.0788 7.15848 17.0225 6.69325 16.5581C6.20863 16.0735 6.15694 15.6665 6.23171 15.2012C6.30648 14.7369 6.59817 14.2006 7.06802 13.7308L14.6834 6.11537C15.8003 4.99937 16.8683 4.14922 17.712 3.86491C18.5566 3.58153 19.1622 3.64245 20.1351 4.61537C20.8625 5.34184 21.636 5.99722 21.8373 6.66368C21.9388 6.99599 21.9388 7.3283 21.7219 7.87476C21.5059 8.42122 21.0342 9.16891 20.136 10.0671C16.3071 13.8978 13.368 16.8351 11.7702 18.4329C10.3514 19.8517 9.0111 20.7988 7.81848 21.0572C6.62494 21.3166 5.49233 21.0406 4.01079 19.5572C2.5274 18.0738 2.00863 16.6375 2.16463 15.1449C2.31971 13.6514 3.22894 12.0314 4.90525 10.356C6.93233 8.32891 11.1637 4.44276 11.1637 4.44276C11.2664 4.36537 11.3517 4.2674 11.4143 4.15512C11.4769 4.04284 11.5153 3.91872 11.5272 3.79072C11.539 3.66272 11.524 3.53366 11.4831 3.4118C11.4421 3.28994 11.3762 3.17798 11.2895 3.08307C11.2028 2.98817 11.0972 2.91242 10.9796 2.86068C10.8619 2.80894 10.7347 2.78235 10.6062 2.78261C10.4776 2.78287 10.3505 2.80997 10.2331 2.86219C10.1156 2.91441 10.0103 2.99058 9.92402 3.08584C9.92402 3.08584 5.68525 6.92307 3.57787 9.02953C1.71048 10.896 0.534481 12.9028 0.318481 14.9723C0.102481 17.04 0.940635 19.0846 2.71294 20.8569C4.48525 22.6292 6.39787 23.2661 8.19325 22.8757C9.98863 22.4861 11.544 21.2557 13.068 19.7317C14.6659 18.1348 17.6049 15.1966 21.4339 11.3658C22.4493 10.3505 23.1065 9.44307 23.4526 8.56891C23.7988 7.69291 23.8126 6.82984 23.5976 6.1163C23.1665 4.69014 22.0099 3.89353 21.4339 3.31845C20.7729 2.65753 20.0419 2.2403 19.2988 2.04922C18.942 1.95054 18.5732 1.90207 18.2031 1.90522V1.9043Z"  />
  //   </svg>

  //   ), style: 'Attach'
  // },
  // {
  //   label: 'Resources', icon: (<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clip-path="url(#clip0_2_93)">
  //       <path d="M7 0C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0L7 0Z"  />
  //       <path d="M13 20C13.5304 20 14.0391 19.7893 14.4142 19.4142C14.7893 19.0391 15 18.5304 15 18V5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3H4C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H13ZM9 5H13V10H9V5ZM4 5H8V6H4V5ZM4 7H8V8H4V7ZM4 9H8V10H4V9ZM4 11H13V12H4V11ZM4 13H13V14H4V13ZM4 15H13V16H4V15Z"  />
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_2_93">
  //         <rect width="20" height="20" rx="10"  />
  //       </clipPath>
  //     </defs>
  //   </svg>
  //   ), style: 'Resources'
  // },
  {
    label: 'Bold', icon: (<Svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path d="M17.061 11.22C17.6659 10.442 17.9961 9.48551 18 8.5C18 6.019 15.981 4 13.5 4H6V19H14C16.481 19 18.5 16.981 18.5 14.5C18.4987 13.8837 18.3702 13.2743 18.1226 12.7099C17.875 12.1456 17.5136 11.6383 17.061 11.22V11.22ZM13.5 7C14.327 7 15 7.673 15 8.5C15 9.327 14.327 10 13.5 10H9V7H13.5ZM14 16H9V13H14C14.827 13 15.5 13.673 15.5 14.5C15.5 15.327 14.827 16 14 16Z" />
    </Svg>
    ), style: 'BOLD'
  },
  {
    label: 'Italic', icon: (<Svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path d="M16.2809 5.33335H11.4009C11.2992 5.32362 11.1965 5.33525 11.0996 5.36751C11.0026 5.39977 10.9135 5.45194 10.8378 5.52067C10.7622 5.58941 10.7018 5.67319 10.6604 5.76664C10.6191 5.8601 10.5977 5.96116 10.5977 6.06335C10.5977 6.16554 10.6191 6.26661 10.6604 6.36006C10.7018 6.45351 10.7622 6.53729 10.8378 6.60603C10.9135 6.67476 11.0026 6.72693 11.0996 6.75919C11.1965 6.79145 11.2992 6.80308 11.4009 6.79335H12.8209L8.74091 17.0334H6.98091C6.87918 17.0236 6.77654 17.0353 6.67958 17.0675C6.58261 17.0998 6.49346 17.1519 6.41783 17.2207C6.34221 17.2894 6.28179 17.3732 6.24044 17.4666C6.19909 17.5601 6.17773 17.6612 6.17773 17.7634C6.17773 17.8655 6.19909 17.9666 6.24044 18.0601C6.28179 18.1535 6.34221 18.2373 6.41783 18.306C6.49346 18.3748 6.58261 18.4269 6.67958 18.4592C6.77654 18.4914 6.87918 18.5031 6.98091 18.4934H11.8676C11.9693 18.5031 12.0719 18.4914 12.1689 18.4592C12.2659 18.4269 12.355 18.3748 12.4307 18.306C12.5063 18.2373 12.5667 18.1535 12.608 18.0601C12.6494 17.9666 12.6707 17.8655 12.6707 17.7634C12.6707 17.6612 12.6494 17.5601 12.608 17.4666C12.5667 17.3732 12.5063 17.2894 12.4307 17.2207C12.355 17.1519 12.2659 17.0998 12.1689 17.0675C12.0719 17.0353 11.9693 17.0236 11.8676 17.0334H10.3409L14.4276 6.79335H16.2809C16.3826 6.80308 16.4853 6.79145 16.5822 6.75919C16.6792 6.72693 16.7684 6.67476 16.844 6.60603C16.9196 6.53729 16.98 6.45351 17.0214 6.36006C17.0627 6.26661 17.0841 6.16554 17.0841 6.06335C17.0841 5.96116 17.0627 5.8601 17.0214 5.76664C16.98 5.67319 16.9196 5.58941 16.844 5.52067C16.7684 5.45194 16.6792 5.39977 16.5822 5.36751C16.4853 5.33525 16.3826 5.32362 16.2809 5.33335V5.33335Z" />
    </Svg>
    ), style: 'ITALIC'
  },
  {
    label: 'Underline', icon: (<Svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path d="M11.9994 18.78C15.3861 18.78 17.6527 16.7266 17.6527 12.78V5.6933C17.6527 5.48997 17.572 5.29497 17.4282 5.15119C17.2844 5.00741 17.0894 4.92664 16.8861 4.92664C16.6827 4.92664 16.4877 5.00741 16.3439 5.15119C16.2002 5.29497 16.1194 5.48997 16.1194 5.6933V12.8933C16.1194 15.8533 14.5327 17.3666 12.0327 17.3666C9.53272 17.3666 7.89272 15.72 7.89272 12.8V5.6933C7.89272 5.48997 7.81195 5.29497 7.66817 5.15119C7.52439 5.00741 7.32939 4.92664 7.12606 4.92664C6.92272 4.92664 6.72772 5.00741 6.58394 5.15119C6.44016 5.29497 6.35939 5.48997 6.35939 5.6933V12.8933C6.35272 16.7266 8.66606 18.78 11.9994 18.78Z" />
      <Path d="M20.6672 20H3.3339C3.15062 20.0175 2.98042 20.1026 2.85656 20.2388C2.7327 20.3751 2.66406 20.5526 2.66406 20.7367C2.66406 20.9208 2.7327 21.0983 2.85656 21.2345C2.98042 21.3707 3.15062 21.4559 3.3339 21.4733H20.6672C20.8505 21.4559 21.0207 21.3707 21.1446 21.2345C21.2684 21.0983 21.3371 20.9208 21.3371 20.7367C21.3371 20.5526 21.2684 20.3751 21.1446 20.2388C21.0207 20.1026 20.8505 20.0175 20.6672 20Z" />
    </Svg>
    ), style: 'UNDERLINE'
  },
  // { label: 'Monospace', style: 'CODE' },
];

const InlineStyleControls = (props: any) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();

  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  let arr = INLINE_STYLES

  return (
    <>
      {arr.map(type => {

        if (type.label === 'Attach') {
          return (<StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            icon={type.icon}
            dataTip={'Attach'}
            onToggle={() => {
              if (props.openDropzone) {
                props.openDropzone()
              }
            }}
            style={type.style}
          />)
        }
        if (type.label === 'Resources') {
          return (<StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            icon={type.icon}
            dataTip={'Add Resources'}
            onToggle={() => {
              if (props.openAddResources) {
                props.openAddResources()
              }
            }}
            style={type.style}
          />)
        }
        return (
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            icon={type.icon}
            onToggle={props.onToggle}
            style={type.style}
            dataTip={type.label}
            tooltip='test'
          />
        )
      }
      )}
    </>
  );
};

const FileMentionComponent: React.FC<{ mention?: any } & PropsWithChildren> = ({ mention: { name, avatar, mention },
  children
}) => {
  return (
    <>
      <span style={{ fontWeight: 500 }}>{`@${mention}`}</span>
      <span style={{ display: "none" }}>{children}</span>
    </>
  );
}
const Avatar = ({ mention, theme = {} }: any) => {
  if (mention.avatar) {
    return (
      <img
        src={mention.avatar}
        className={theme.mentionSuggestionsEntryAvatar}
        role="presentation"
      />
    );
  }

  return null;
};
const CustomMentionEntryComponent = (props: any) => {
  const {
    mention,
    theme,
    isFocused, // eslint-disable-line no-unused-vars
    searchValue, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps}>
      <Avatar mention={mention} theme={theme} />
      <span className={theme.mentionSuggestionsEntryText}>{mention.displayName}</span>
    </div>
  );
};

const customLinkifyPlugin = createLinkifyPlugin({
  component(props) {
    return <a {...props} target='_blank' onClick={() => console.log('clicked')} />;
  },
  customExtractLinks: (text) => {
    return text as any
  }

});

const linkPlugin = createLinkPlugin({
  theme: linkStyles as any,
  placeholder: 'http://…',
});

const TextEditorWithUsers: React.FC<ITextEditorProps & {
  data: IGetHelpscoutUsersOutput | undefined,
  loading: boolean
}> = ({ session, data, loading, setFieldValue, name }) => {
  const [files, setfiles] = useState<Array<{
    fileName: string,
    mimeType: string,
    data: string | ArrayBuffer | null | undefined,
    size: number,
  }>>([]);

  const [showAddResource, setShowAddResource] = useState(false)
  const [isShowingChildModal, setIsShowingChildModal] = useState(false)
  const [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(linkDecorator),
  );
  const [showInsertLink, setShowInsertLink] = useState<boolean>(false);
  const [openMentions, setOpenMentions] = useState(false);
  const [suggestionsMention, setSuggestionsMention] = useState<MentionData[] | null>();
  const inputRef = useRef<any>();
  useEffect(() => {
    if (loading || !data?.getHelpscoutUsers) return

    let opts = [{
      label: 'Anyone',
      value: -1
    }]

    opts = [...opts, ...transformToOption(data.getHelpscoutUsers, session)]
    setSuggestionsMention(data.getHelpscoutUsers.map(x => {
      return {
        displayName: `${x.firstName} ${x.lastName}`,
        name: `@${x.mention}` || '',// `${x.firstName} ${x.lastName}`,
        mention: x.mention,
        avatar: x.photoUrl
      }
    }))
    if (inputRef && inputRef.current) {
      inputRef.current.focus()
    }
  }, [loading, data])
  const [{ plugins, MentionSuggestions, InlineToolbar }] = useState(() => {
    const toolbarPlugin = createInlineToolbarPlugin();
    const { InlineToolbar } = toolbarPlugin
    const customMentionPlugin = createMentionPlugin({
      mentionTrigger: "@",
      mentionComponent: FileMentionComponent
    });
    const linkifyPlugin = createLinkifyPlugin();
    // eslint-disable-next-line no-shadow
    const { MentionSuggestions } = customMentionPlugin;
    // eslint-disable-next-line no-shadow
    const plugins = [customMentionPlugin, customLinkifyPlugin, linkPlugin, toolbarPlugin];
    return {
      plugins,
      MentionSuggestions,
      InlineToolbar
    };
  });

  const transformToOption = (users: IHelpscoutUser[], session: IUser) => {
    return [...users].sort((a, b) => {
      if (a.id === session.helpscoutId) return -1
      return 1
    }).map(x => {
      return {
        label: x.id === session.helpscoutId ? 'Me' : `${x.firstName} ${x.lastName}`,
        value: x.id
      }
    })
  }

  const _handleKeyCommand = (command: any) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      onChange(newState);
      return true;
    }
    return false;
  }
  const onChange = (e: EditorState) => {
    setEditorState(e)

    const content = editorState.getCurrentContent();
    const dataToSaveBackend = convertToRaw(content);
    const html = convertToHTML({
      entityToHTML: (entity, originalText) => {
        if (entity.type === 'LINK') {
          return <a href={entity.data.url}>{originalText}</a>;
        }
        if (entity.type === 'mention') {
          /* tslint:disable-next-line */
          return <b className="mention-highlight">{originalText}</b>
        }
        return originalText;
      }
    })(editorState.getCurrentContent());
    setFieldValue(name, html)
    // e.
  }
  const _onTab = (e: any) => {
    const maxDepth = 4;
    onChange(RichUtils.onTab(e, editorState, maxDepth));
  }

  const _toggleBlockType = (blockType: any) => {
    onChange(
      RichUtils.toggleBlockType(
        editorState,
        blockType
      )
    );
  }

  const _toggleInlineStyle = (inlineStyle: any) => {
    onChange(
      RichUtils.toggleInlineStyle(
        editorState,
        inlineStyle
      )
    );
  }
  const toggleBlockType = (type: any) => _toggleBlockType(type);
  const toggleInlineStyle = (style: any) => _toggleInlineStyle(style);
  const onOpenMentionsChange = useCallback((_open: boolean) => {
    setOpenMentions(_open);
  }, []);

  const onSearchMentionChange = useCallback(({ trigger, value }: { trigger: string; value: string }) => {
    setSuggestionsMention(
      defaultSuggestionsFilter(value, data!.getHelpscoutUsers!.map(x => {
        return {
          displayName: `${x.firstName} ${x.lastName}`,
          name: `@${x.mention}` || '',// `${x.firstName} ${x.lastName}`,
          mention: x.mention,
          avatar: x.photoUrl
        }
      }), trigger) as MentionData[]
    )
  }, []);

  const onDiscard = () => {
    const content = editorState.getCurrentContent();
    const dataToSaveBackend = convertToRaw(content);
    const html = convertToHTML({
      entityToHTML: (entity, originalText) => {
        if (entity.type === 'LINK') {
          return <a href={entity.data.url}>{originalText}</a>;
        }
        if (entity.type === 'mention') {
          /* tslint:disable-next-line */
          return <b className="mention-highlight">{originalText}</b>
        }
        return originalText;
      }
    })(editorState.getCurrentContent());

    if (!html || html === '<p></p>') {
      // onDeleteHandler()
    } else {
      // setconfirmDiscard(true)
    }
  }

  const onSendReply = () => {
    const content = editorState.getCurrentContent();
    const dataToSaveBackend = convertToRaw(content);
    const html = convertToHTML({
      entityToHTML: (entity, originalText) => {
        if (entity.type === 'LINK') {
          return <a href={entity.data.url}>{originalText}</a>;
        }
        if (entity.type === 'mention') {
          /* tslint:disable-next-line */
          return <b className="mention-highlight">{originalText}</b>
        }
        return originalText;
      }
    })(editorState.getCurrentContent());
    const attachments = [];
    if (files) {
      for (let index = 0; index < files.length; index++) {
        const element = files[index];
        if (!element.data) continue
        attachments.push({
          ...element,
          data: ((element.data) as string).substr(((element.data) as string).indexOf(',') + 1),
        });
      }
    }
    if ((!html || html === '<p></p>') && (!attachments || attachments.length < 1)) {
      // onDeleteHandler()
    } else {
      // sendReplyHandler(html, assignTo || -1, changeStatus || 'closed', attachments)
    }
  }

  const sendTextToEditor = (text: string) => {
    setEditorState(insertText(text, editorState))
    focusEditor();
  }


  const focusEditor = async () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus()
      await sleep(300)
    }
  };

  const insertText = (text: string, es: EditorState) => {
    const currentContent = editorState.getCurrentContent(),
      currentSelection = editorState.getSelection();

    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      text
    );

    const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
    return EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
  }

  const insertTextAfterResource = (text: string, editoState: EditorState) => {
    console.log('InsertText', { text })
    let es = editoState
    const currentContent = es.getCurrentContent(),
      currentSelection = es.getSelection();

    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      text
    );

    es = EditorState.push(es, newContent, 'insert-characters');

    console.log('InsertText es', { es })
    return EditorState.forceSelection(es, newContent.getSelectionAfter());
  }

  const insertResourceLink = (text: string, link: string, editoState: EditorState) => {
    // const link = links[index];
    const content = editoState.getCurrentContent();
    const currentContent = editoState.getCurrentContent();
    const selection = editoState.getSelection();
    const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link });
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    const textWithEntity = Modifier.insertText(currentContent, selection, text, undefined, entityKey);
    const newEditorState = EditorState.push(editoState, textWithEntity, 'insert-characters');
    editoState = (RichUtils.toggleLink(newEditorState, selection, entityKey))

    return EditorState.forceSelection(editoState, textWithEntity.getSelectionAfter())
  }

  if (!!loading || !suggestionsMention) return null

  return (
    <Flex flexDirection={'column'}>
      <Flex style={{ width: '100%', }}>
        <Flex flexDirection={'row'} style={{ width: 'auto', alignSelf: 'flex-start', paddingRight: '8px' }}>
          <InlineStyleControls
            openDropzone={() => { }}
            openAddResources={() => {
              setShowAddResource(true)
            }}
            editorState={editorState}
            onToggle={toggleInlineStyle}
          />
          <BlockStyleControls
            onDeleteHandler={onDiscard}
            editorState={editorState}
            onToggle={toggleBlockType}
            showInsertLink={() => setShowInsertLink(true)}
          />

        </Flex>
      </Flex>
      <Container >
        <EditorWrapper width={'100%'} flex={1} id='bxEditor' paddingX='12px' marginBottom='12px' marginTop='12px' style={{ backgroundColor: 'white', color: '' }} maxHeight={['', '226px', '226px']} overflowY={['hidden', 'auto', 'auto']} onClick={() => {
          if (inputRef && inputRef.current) {
            inputRef.current.focus()
          }
        }}>
          <Editor
            ref={inputRef}
            blockStyleFn={getBlockStyle as any}
            customStyleMap={styleMap}
            editorState={editorState}
            handleKeyCommand={_handleKeyCommand as any}
            onChange={onChange}
            onTab={_onTab}
            decorators={linkDecorators}
            // placeholder="Tell a story..."
            // ref="editor"
            spellCheck={true}
            plugins={plugins}
          />
          <InlineToolbar>
            {(externalProps: any) => (
              <>
                <linkPlugin.LinkButton {...externalProps} />
              </>
            )}
          </InlineToolbar>
          {suggestionsMention && (
            <MentionSuggestions
              open={openMentions}
              onOpenChange={onOpenMentionsChange}
              suggestions={suggestionsMention!}
              onSearchChange={onSearchMentionChange}
              entryComponent={CustomMentionEntryComponent}
              onAddMention={() => {
                // get the mention object selected
              }}
            />)}
        </EditorWrapper>

        <ReactTooltip place="bottom" type="dark" effect="solid" />

        {!!showInsertLink && (
          <Modal
            isOpen={!!showInsertLink}
            onBackgroundClick={() => setShowInsertLink(false)}
            onEscapeKeydown={() => setShowInsertLink(false)}>
            <InsertLinkModalContent
              onCancel={() => setShowInsertLink(false)} okPressed={(link, text) => {
                const selection = editorState.getSelection();

                const content = editorState.getCurrentContent();
                const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link });
                const newEditorState = EditorState.push(editorState, contentWithEntity, 'apply-entity');
                const entityKey = contentWithEntity.getLastCreatedEntityKey();
                setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey))

              }} />
          </Modal>)}

      </Container>
    </Flex>);
}

const TextEditorEmbed: React.FC<ITextEditorProps> = ({ session, properties, name, values, setFieldValue, touched, errors }) => {
  const { data, loading, error } = useQuery<IGetHelpscoutUsersOutput, IIGetHelpscoutUsersInput>(GET_HELPSCOUT_USERS)
  if (!!loading) return null

  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4} style={{ userSelect: 'none' }}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300} style={{ userSelect: 'none' }}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <FormField ml={3} flex={1} mb={0} error={touched[name] && errors[name]}>
        <TextEditorWithUsers touched={touched} errors={errors} properties={properties} name={name} values={values} setFieldValue={setFieldValue} session={session} data={data} loading={loading} />
      </FormField>
    </Flex>)
}

export default withSession(TextEditorEmbed)